import { groupBy } from "lodash";
import { FacetHit } from "meilisearch";

export type HierarchicalFacet = FacetHit & {
  isRefined: boolean;
  items: HierarchicalFacet[];
};

export function buildHierarchicalTree(
  facets: (FacetHit & { isRefined: boolean })[],
  separator: string = "/",
): HierarchicalFacet[] {
  // Group facets by parent path (everything before last separator)
  const byParent = groupBy(facets, (facet) => {
    const parts = facet.value.split(separator);
    return parts.slice(0, -1).join(separator); // parent = all but last segment
  });

  const buildChildren = (
    parentPath: string,
    visited = new Set<string>(),
  ): HierarchicalFacet[] => {
    if (visited.has(parentPath)) return [];
    visited.add(parentPath);

    return (byParent[parentPath] || []).map((facet) => ({
      ...facet,
      items: buildChildren(facet.value, visited),
    }));
  };

  // Root facets have empty parent string
  return buildChildren("");
}
